<template>
    <Table border :columns="columns" :data="data" class="de-table-wrapper" :style="fontStyle"></Table>
</template>

<script>
export default {
    name: 'de-table',
    props: {
        fontObj: {
            type: Object
        },
        titleArr: {
            type: Array,
            default: () => {
                return [
                    {
                        title: '领域',
                        key: 'name',
                        width: 100
                    },
                    {
                        title: '建设内容',
                        key: 'age'
                    },
                    {
                        title: '目标',
                        key: 'address'
                    }
                ];
            }
        },
        listData: {
            type: Array,
            default: () => {
                return [
                    {
                        name: 'John Brown',
                        age: 18,
                        address: 'New York No. 1 Lake Park',
                        date: '2016-10-03'
                    },
                    {
                        name: 'Jim Green',
                        age: 24,
                        address: 'London No. 1 Lake Park',
                        date: '2016-10-01'
                    },
                    {
                        name: 'Joe Black',
                        age: 30,
                        address: 'Sydney No. 1 Lake Park',
                        date: '2016-10-02'
                    },
                    {
                        name: 'Jon Snow',
                        age: 26,
                        address: 'Ottawa No. 2 Lake Park',
                        date: '2016-10-04'
                    }
                ]
            }
        }
    },
    computed: {
        fontStyle() {
            return this.fontObj
            ? Object.assign({}, this.fontObj, {
                fontSize: `${this.fontObj.fontSize}px`
            })
            : {}
        },
        columns() {
            return this.titleArr.concat([]);
        },
        data() {
            return this.listData.concat([]);
        }
    }
}
</script>

<style lang="less">
.de-table-wrapper {
    .ivu-table {
        color: #fff;
        background-color: transparent;
        th {
            background: transparent;
        }
        td {
            background: transparent;
        }
        .ivu-table-overflowX {
            overflow: hidden;
        }
    }
}
</style>